import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=21489bee&scoped=true&"
import script from "./ShippingAddress.vue?vue&type=script&lang=js&"
export * from "./ShippingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=21489bee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21489bee",
  null
  
)

export default component.exports